import React from "react";
import { Modal } from "react-bootstrap";
import FormInputs from "../../../../../../components/UI/FormInputs";
import { isSet } from "../../../../../../utils/commonUtils";
import Button from "../../../../../../components/UI/Buttons/Button";


const AddLabPanel = (props) => {
    const { inputFields, toogleHandler, submiHandler, validation, changeHandler, formData} = props;

    return (
        <Modal
            show={true}
            onHide={toogleHandler}
            keyboard={false}
            contentClassName='h-100'
            backdrop="static"
            size="md"
        >
            <div className="sh_modalBox1">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h6 className="text-lg mb-0 font-weight-bold">
                            {formData.id ? 'Edit Lab Panel' : 'Add Lab Panel'}
                        </h6>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        {inputFields.map((itm, ind) => {
                            // Handle checkbox with multiple options - render multiple checkboxes with labels
                            if (itm.type === 'Checkbox' && itm.options && Array.isArray(itm.options) && itm.options.length > 0) {
                                // Get current value - could be a string (comma-separated) or array
                                const currentValue = formData[itm.name] || '';
                                const selectedValues = typeof currentValue === 'string' 
                                    ? currentValue.split(',').filter(v => v !== '')
                                    : (Array.isArray(currentValue) ? currentValue : []);
                                
                                return (
                                    <div className="row" key={ind}>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-6">
                                                        <label className="text-sm text-truncate mb-0 opacity-75">{itm.label}</label>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="d-flex flex-wrap">
                                                            {itm.options.map((option, optIndex) => {
                                                                const optionValue = option.value !== undefined ? option.value : (typeof option === 'string' ? option : '');
                                                                const optionLabel = option.label !== undefined ? option.label : (typeof option === 'string' ? option : optionValue);
                                                                const isChecked = selectedValues.includes(optionValue.toString());
                                                                
                                                                return (
                                                                    <div className="form-check form-check-inline d-inline-flex mr-3" key={optIndex}>
                                                                        <FormInputs
                                                                            type="Checkbox"
                                                                            name={itm.name}
                                                                            id={`${itm.name}_${optIndex}`}
                                                                            value={isChecked}
                                                                            className="form-check-input"
                                                                            changeHandler={(checked) => {
                                                                                let newValues;
                                                                                if (checked) {
                                                                                    // Add to selection
                                                                                    newValues = [...selectedValues, optionValue.toString()];
                                                                                } else {
                                                                                    // Remove from selection
                                                                                    newValues = selectedValues.filter(v => v !== optionValue.toString());
                                                                                }
                                                                                // Convert back to comma-separated string or array
                                                                                const finalValue = newValues.join(',');
                                                                                changeHandler(itm.name, finalValue);
                                                                            }}
                                                                        />
                                                                        <label 
                                                                            className="form-check-label-text font-weight-bold pl-1 mb-0" 
                                                                            htmlFor={`${itm.name}_${optIndex}`}
                                                                        >
                                                                            {optionLabel}
                                                                        </label>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                        {isSet(validation[itm.name], '') !== '' && (
                                                            <span className="text-danger m-1">
                                                                {isSet(validation[itm.name], '')}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                            
                            // Default rendering for other field types
                            return (
                                <div className="row" key={ind}>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-6">
                                                    <label className="text-sm text-truncate mb-0 opacity-75">{itm.label}</label>
                                                </div>
                                                <div className="col-6">
                                                    <FormInputs
                                                        changeHandler={(value, e) => changeHandler(itm.name, value, e)}
                                                        value={formData[itm.name]}
                                                        {...itm}
                                                    />
                                                    {isSet(validation[itm.name], '') !== '' && (
                                                        <span className="text-danger m-1">
                                                            {isSet(validation[itm.name], '')}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center">
                    <Button
                        className="btn btn-primary btn-sm text-sm"
                        acl={'any'}
                        clickHandler={() => submiHandler()}
                    >
                        {formData.id ? 'Update' : 'Save'}
                    </Button>
                </Modal.Footer>
            </div>
        </Modal>
    );
}

export default AddLabPanel;